// extracted by mini-css-extract-plugin
export var carrierNotice = "_kv-5";
export var carrierNoticePlaceholder = "_kv-6";
export var deliveryRow = "_kv-c";
export var fixedHeight = "_kv-4";
export var freightLogo = "_kv-b";
export var fullWidth = "_kv-3";
export var priceColumn = "_kv-7";
export var radioSelected = "_kv-9";
export var radioUnselected = "_kv-8";
export var selectedOption = "_kv-2";
export var selectedOptionContainer = "_kv-1";
export var selection = "_kv-0";
export var tallSkeletonText = "_kv-a";